/**
 * @generated SignedSource<<9d5de50ecc05a1e503b8cc774684627b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteClientInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteClientMutation$variables = {
  input: DeleteClientInput;
};
export type deleteClientMutation$data = {
  readonly deleteClient: {
    readonly deletedClientId: string | null;
  } | null;
};
export type deleteClientMutation = {
  variables: deleteClientMutation$variables;
  response: deleteClientMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteClientPayload",
    "kind": "LinkedField",
    "name": "deleteClient",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedClientId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteClientMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteClientMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dd6c16359d3c6260b9953538d41772c1",
    "id": null,
    "metadata": {},
    "name": "deleteClientMutation",
    "operationKind": "mutation",
    "text": "mutation deleteClientMutation(\n  $input: DeleteClientInput!\n) {\n  deleteClient(input: $input) {\n    deletedClientId\n  }\n}\n"
  }
};
})();

(node as any).hash = "4dceffefee02f585556b2e999d63bcf3";

export default node;
